import { render, staticRenderFns } from "./ECommerce.vue?vue&type=template&id=168e110e&scoped=true"
import script from "./ECommerce.vue?vue&type=script&lang=ts"
export * from "./ECommerce.vue?vue&type=script&lang=ts"
import style0 from "./ECommerce.vue?vue&type=style&index=0&id=168e110e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168e110e",
  null
  
)

export default component.exports